export enum ActionRequestAction {
  ADD_OR_VERIFY_PHONE_NUMBER = 'addOrVerifyPhoneNumber',
  JOIN_COMPANY = 'joinCompany',
  JOIN_PROJECT = 'joinProject',
  ENABLE_ALERT_NOTIFICATIONS = 'enableAlertNotifications',
  SELECT_COUNTRY_CODE = 'selectCountryCode',
  SELECT_COORDINATES = 'selectCoordinates',
  SELECT_EIC_AREA_CODE = 'selectEicAreaCode'
}
